import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLockedAccountUsername, getReturnToLoginError, setLockedAccountUsername, setReturnToLoginError, } from '../store';
export var useAccountLockout = function (form) {
    var dispatch = useDispatch();
    var initialError = useSelector(getReturnToLoginError);
    var lockedUsername = useSelector(getLockedAccountUsername);
    useEffect(function () {
        return function () {
            dispatch(setReturnToLoginError(null));
        };
    }, []);
    useEffect(function () {
        if (lockedUsername) {
            form.setValue('username', lockedUsername);
        }
    }, [lockedUsername]);
    useEffect(function () {
        var subscription = form.watch(function (values) {
            // If username is changed and doesn't match locked username, enable password field
            if (lockedUsername && values.username !== lockedUsername) {
                dispatch(setLockedAccountUsername(null));
            }
        });
        return function () { return subscription.unsubscribe(); };
    }, [lockedUsername]);
    return {
        error: initialError,
        isFormDisabled: !!lockedUsername,
        isPasswordDisabled: !!lockedUsername,
    };
};
